import { Button, Typography, TableContainer, Table, TableHead, TableRow, TableBody, Paper, TableCell, RadioGroup, FormControlLabel, Radio } from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles'
import { DialogMessage } from "../../../global/DialogMessage"
import { ToastMessage } from "../../../global/ToastMessage"
import { useState } from "react"
import { useSelector } from "react-redux"
import useApi from "../../../hooks/useAPI"
import { FormatoFechaIso } from "../../../utils/FormatFecha"
import { formatDinero } from "../../../utils/formatDinero"
import { DIAS_RESTANTES_CAMBIOS_FECHA } from "../../../constant/constantes"
import { aplicarCambioFecha, obtenerCotizacionAction, obtnerViajeRefenciaAction } from "../../../ducks/cambiosDuck"
import { useDispatch } from "react-redux"
import BackDrop from "./../../../global/BackDrop"
export const VCambioPasajerosStyle = makeStyles((theme) => ({
    root: {
        margin: "10px 0",
    },
    content: {
        margin: "20px 0",
    },
    contentButton: {
        margin: "20px 0",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center"
    },
    container: {
        maxHeight: 440,
    }
}))

const CambioFecha = () => {
    const classes = VCambioPasajerosStyle()
    const dispatch = useDispatch()
    const { cliente, viaje, diasRestantes, referencia } = useSelector(store => store.cambios)
    const [value, setValue] = useState("0,0,0")
    const [idObjeto, setIdObjeto] = useState(0)
    const [load, setLoad] = useState(false)
    const [fecha, setFecha] = useState("N/A")
    const [IdBloque, setIdBloque] = useState(0)
    const catalogoFechas = useApi(`Package/TravelDate/${cliente?.paquete?.ClavePaquete}`)
    const penalizacion = useApi(`Package/Penalty/TravelDate/${IdBloque}/${idObjeto}/${cliente?.paquete?.Id_Paquete}`)
    const onCancelar = () => {
        DialogMessage.fire({
            title: '¿Estas seguro de aplicar este cambio?',
            text: '',
            showCancelButton: true,
            confirmButtonText: "Aplicar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoad(true)
                dispatch(aplicarCambioFecha({ IdPaquete: viaje?.Paquete?.Id_Paquete, IdBloqueSalida: IdBloque, IdObjeto: idObjeto })).then(Response => {
                    setLoad(false)
                    if (Response?.status === 500) {
                        ToastMessage.fire({
                            icon: "error",
                            title: "Ha habido un problema de conexión con el servidor",
                        });
                        return null
                    }
                    if (Response?.status === 400) {
                        ToastMessage.fire({
                            icon: "warning",
                            text: Response?.Message,
                        });
                        return null
                    }
                    dispatch(obtnerViajeRefenciaAction())
                    dispatch(obtenerCotizacionAction({Referencia: referencia }))
                    ToastMessage.fire(
                        'Se aplico el cambio de fecha',
                        '',
                        'success'
                    )
                })
            }
        })
    }
    const handleChange = (value) => {
        const valor = value.target.value.split(",")
        setValue(value.target.value)
        setFecha(valor[0])
        setIdObjeto(valor[2])
        setIdBloque(valor[1])
    }
    if (diasRestantes <= DIAS_RESTANTES_CAMBIOS_FECHA)
        return <div style={{ textAlign: "center" }}>
            <h2>No es posible cambiar la fecha de salida</h2>
            <h2>Se supero el limete de dias para aplicar este cambio</h2>
        </div>
    return (
        <div className={classes.root}>
            <div className={classes.content}>
                <Typography variant="h6">
                    Penalizacion: {`${formatDinero(penalizacion.MontoPenalizacion)} ${viaje.Moneda.Clave}`}
                </Typography>
                <Typography variant="h6">
                    Monto adcional por suplemento: {`${formatDinero(penalizacion.MontoPaquete - viaje?.Paquete?.Monto_Paquete)} ${viaje.Moneda.Clave}`}
                </Typography>
                <Typography variant="h6">
                    Nuevo monto paquete: {`${formatDinero(penalizacion.MontoPaquete)} ${viaje.Moneda.Clave}`}
                </Typography>
                <Typography variant="h6">
                    Total no cobrado:  {`${formatDinero((penalizacion.MontoPenalizacion - viaje?.Suma < 0) ? 0 : penalizacion.MontoPenalizacion - viaje?.Suma)} ${viaje.Moneda.Clave}`}
                </Typography>
                <Typography variant="h6">
                    Nueva fecha de salida: {(fecha !== "N/A" ? FormatoFechaIso({ date: fecha, formato: "dd MMMM yyyy" }) : "N/A")}
                </Typography>
            </div>
            <div>
                <TableContainer component={Paper} className={classes.container}>
                    <Table stickyHeader aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell align="center">Nombre</TableCell>
                                <TableCell align="center">Fecha</TableCell>
                                <TableCell align="center">Precio por persona</TableCell>
                                <TableCell align="center">Seleccionar</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody component={RadioGroup} value={value} onChange={handleChange}>
                            {
                                catalogoFechas.map((Salida, index) =>
                                    <TableRow key={index}>
                                        <TableCell align="center">
                                            {Salida.Descripcion}
                                        </TableCell>
                                        <TableCell align="center">
                                            {FormatoFechaIso({ date: Salida.FechaSalida, formato: "dd MMMM yyyy" })}
                                        </TableCell>
                                        <TableCell align="center">
                                            {formatDinero(Salida.Precio)}
                                        </TableCell>
                                        <TableCell align="center">
                                            <FormControlLabel value={`${Salida.FechaSalida},${Salida.IdBloqueSalida},${Salida.IdObjeto}`} control={<Radio />} />
                                        </TableCell>
                                    </TableRow>
                                )
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
            <div className={classes.contentButton}>
                <Button onClick={onCancelar} variant="contained" color="primary" disabled={value !== "N/A" ? false : true}>
                    Aplicar Cambio
                </Button>
            </div>
            <BackDrop open={load} />
        </div>
    )
}
export default CambioFecha